import { render } from "./ComplianceAgentChat.vue?vue&type=template&id=6a31f69a&scoped=true"
import script from "./ComplianceAgentChat.vue?vue&type=script&lang=js"
export * from "./ComplianceAgentChat.vue?vue&type=script&lang=js"

import "./ComplianceAgentChat.vue?vue&type=style&index=0&id=6a31f69a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a31f69a"]])

export default __exports__